import { useState } from "react";
import { Table, Pagination, ConfigProvider } from "antd";
import styles from "./NewsLetterTable.module.scss";
import ActiveIcon from "../../../assets/icons/ActiveIcon";
import BlockedIcon from "../../../assets/icons/BlockedIcon";
import EditIcon from "../../../assets/icons/EditIcon";
import DeleteIcon from "../../../assets/icons/DeleteIcon";
import TelegramIcon from "../../../assets/icons/TelegramIcon";
import CustomTable from "../CustomTable/CustomTable";
import { useTranslation } from "react-i18next";

const NewsLetterTable = () => {
  const { t } = useTranslation();
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const columns = [
    {
      title: t("newsletterTable.channel"),
      dataIndex: "channel",
      key: "channel",
      render: (text) => (
        <p className={styles.tableName}>
          <TelegramIcon /> {text}
        </p>
      ),
    },
    {
      title: t("newsletterTable.lastMessageInterval"),
      dataIndex: "lastMessageInterval",
      key: "lastMessageInterval",
      align: "center",
    },
    {
      title: t("newsletterTable.active"),
      dataIndex: "isActive",
      key: "isActive",
      align: "center",
      render: (item) => <div>{item ? <ActiveIcon /> : <BlockedIcon />}</div>,
    },
    {
      title: t("newsletterTable.useAI"),
      dataIndex: "useAI",
      key: "useAI",
      align: "center",
      render: (item) => <div>{item ? <ActiveIcon /> : <BlockedIcon />}</div>,
    },
    {
      title: t("newsletterTable.messageInstruction"),
      dataIndex: "message",
      key: "message",
    },
    {
      title: t("newsletterTable.actions"),
      key: "actions",
      render: () => (
        <div className={styles.tableActions}>
          <button className={styles.delete}>
            <DeleteIcon />
          </button>
          <button className={styles.edit}>
            <EditIcon />
          </button>
        </div>
      ),
      align: "center",
    },
  ];

  const mockData = Array.from({ length: 12 }, (_, i) => ({
    key: i,
    channel: `Канал ${i + 1}`,
    lastMessageInterval: `${Math.floor(Math.random() * 60)} мин`,
    isActive: false,
    useAI: true,
    message: `Сообщение ${i + 1}`,
  }));

  return <CustomTable columns={columns} mockData={mockData} />;
};

export default NewsLetterTable;
